import { atom } from 'recoil';
import { resetOrder, resetToggleSspModal } from '../utils';

export const toggleSspModels = atom({ key: 'sqs-toggleSspModels', default: resetToggleSspModal });
export const orderId = atom({ key: 'sqs-orderId', default: '' });
export const sspSubmitOrder = atom({ key: 'sqs-sspOrder', default: resetOrder });
export const costEstimateState = atom({ key: 'sqs-costEstimateState', default: null });
export const isLoadingCostApiState = atom({ key: 'sqs-isLoadingCostApiState', default: { isLoading: false } });
export const isAppNameValid = atom({ key: 'sqs-isAppNameValid', default: false });
export const isAppShortNameValid = atom({ key: 'sqs-isAppShortNameValid', default: false });
export const isAppShortNameExist = atom({ key: 'sqs-isAppShortNameExist', default: false });
